<template>
  <v-card
    elevation="2"
    outlined
    style="width: 800px"
  >
    <v-card-title class="title text--primary text-left">
      {{ $t("terms.title") }}
    </v-card-title>
    <v-card-text class="text--primary text-left">
      <div class="termsText">
        <!-- Se også app.vue  -->
        <p v-text="$t('terms.p1')" />
        <ul>
          <li v-text="$t('terms.li1')" />
          <li v-text="$t('terms.li2')" />
          <li v-text="$t('terms.li3')" />
          <li v-text="$t('terms.li4')" />
          <li v-text="$t('terms.li5')" />
        </ul>
      </div>
      <div class="termsTextFooter mb-2">
        {{ $t("terms.textFooter") }}
      </div>
      <v-divider />
      <p
        v-if="loaded"
        class="text-right font-weight-bold font-italic mt-2"
      >
        {{ $t('terms.termsAcceptedOn') }}
        {{ model.data.termsAcceptedOnDate }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Terms",
  data() {
    return {
      model: Object,
      //view only
      loaded: false,
    };
  },
  created() {
    this.$api.get("users").then((response) => {
      this.model.data = response.data;
      this.loaded = true;
    });
  },
};
</script>